export default __webpack_public_path__ + "static/media/3.cc800ed1.jpg";